import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Field } from '~/components/promotion/editor-section';
import { EntityMultiSelect } from '~/components/promotion/entity-multi-select';
import { loadMockProducts } from '~/lib/lookups/mock';
import type { PromotionAction } from '~/lib/schemas/actions';

type Action = Extract<PromotionAction, { type: 'gift-product' }>;

interface Props {
	value: Action;
	onChange: (next: Action) => void;
}

export function GiftProductBody({ value, onChange }: Props) {
	const { t } = useTranslation();
	const setPrompt = (index: number, text: string) =>
		onChange({ ...value, prompts: value.prompts.map((p, i) => (i === index ? { ...p, text } : p)) });

	return (
		<div className="flex flex-col gap-4">
			<div className="grid grid-cols-[140px_1fr] gap-3">
				<Field label={t('promotion.action.gift.maxSelections')}>
					<Input
						type="number"
						min={1}
						value={value.maxSelections}
						onChange={e => onChange({ ...value, maxSelections: Number(e.target.value) || 1 })}
					/>
				</Field>
				<Field label={t('promotion.action.gift.products')}>
					<EntityMultiSelect
						value={value.productIds}
						onChange={productIds => onChange({ ...value, productIds })}
						options={[]}
						loadOptions={loadMockProducts}
						placeholder={t('common.search')}
					/>
				</Field>
			</div>
			<Field label={t('promotion.action.gift.prompt')} help={t('promotion.action.gift.promptHelp')}>
				<div className="flex flex-col gap-2">
					{value.prompts.map((prompt, index) => (
						<div key={prompt.locale} className="flex items-center gap-2">
							<span className="rounded bg-muted px-2 py-1 font-mono text-xs uppercase text-foreground-subtle">{prompt.locale}</span>
							<Input value={prompt.text} onChange={e => setPrompt(index, e.target.value)} className="flex-1" />
						</div>
					))}
				</div>
			</Field>
		</div>
	);
}
